export default __webpack_public_path__ + "static/media/prev-IVTS-4.08cd9531.png";